import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '@s/FormattedCurrency';
import { TranslationContext } from '../../../../checkout/config/Translations'
import clsx from 'clsx';
import { DeliveryMethod } from './DeliveryMethod';
import { DeliveryDescription } from './DeliveryDescription';
import { DELIVERY_TYPE_EMAIL } from '../reducers/delivery';

const DeliveryOptions = props => {
    const translate = React.useContext(TranslationContext).t;

    const onDeliveryChange = e => {
        e.stopPropagation();
        if (props.disabled) {
          return;
        }
        props.onDeliveryChange(props.delivery_option);
    }

    const hideRadio = !props.isKioskMode && props.single;


    const name = props.delivery_option.name;

    const hidePrice = !props.hasPaidOption;

    const id = `${props.delivery_option.method_name}-${props.delivery_option.id}`;

    return(
        <div
          className={clsx("input__radio delivery__option", {
            'input__radio--selected': props.selected,
            'input__radio--no-radio': hideRadio
          })}
          onClick={onDeliveryChange}
        >
            <div className="input__radio-wrap">
                {!hideRadio && (
                    <Fragment>
                        <div className="input__radio__input">
                            {props.isKioskMode ?
                                <div className="kiosk__delivery-input__radio">
                                    <input name="delivery" type="radio"
                                        id={id}
                                        value={props.delivery_option.id}
                                        checked={props.selected}
                                        readOnly
                                        aria-labelledby={`delivery-options__legend label-${id}`}
                                    />
                                    <i className={`input__radio__mask ${props.selected ? "icon-radio_on" : "icon-radio_off"}`} aria-hidden="true"></i>
                                </div>
                            :
                                <input name="delivery" type="radio"
                                    id={id}
                                    value={props.delivery_option.id}
                                    checked={props.selected}
                                    readOnly
                                    disabled={props.disabled}
                                    aria-labelledby={`delivery-options__legend label-${id}`}
                                />
                            }
                        </div>
                        <label id={`label-${id}`} className="input__radio__label" htmlFor={id}>
                            <div className="input__radio__label-text">{name}</div>
                            {(!props.isKioskMode || +props.price > 0) && !hidePrice && (
                                <div className="input__radio__extra">
                                    <FormattedCurrency>{props.price}</FormattedCurrency>
                                </div>
                            )}
                        </label>
                    </Fragment>
                )}
                {hideRadio && (
                    <div className="input__radio__label">
                        <div className="input__radio__label-text">{name}</div>
                        {(!props.isKioskMode || +props.price > 0) && !hidePrice && (
                            <div className="input__radio__extra">
                                <FormattedCurrency>{props.price}</FormattedCurrency>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <DeliveryDescription deliveryOption={props.delivery_option} isKioskMode={props.isKioskMode} />
            <DeliveryMethod {...props} deliveryOption={props.delivery_option} selected={!!props.selected} />
        </div>
    );
}

DeliveryOptions.defaultProps = {
    selected: false
}

DeliveryOptions.propTypes = {
    selected: PropTypes.bool,
    delivery_option: PropTypes.object.isRequired,
    onDeliveryChange: PropTypes.func.isRequired,
    price: PropTypes.number.isRequired,
    phone: PropTypes.string,
    gatewayType: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
}

export default DeliveryOptions
